import type { PatchModel } from "@shared/models/patch"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "@shared/actions/action-doc-builder"

interface Base {
  userId: string
}

interface StringEntries extends Base {
  field: "firstName" | "lastName" | "canonicalGroupId" | "title"
  value: string | null
}
interface Salutation extends Base {
  field: "salutation"
  value: "Mr" | "Mrs" | "Ms" | "Miss" | "Dr" | "Mx" | "" | null
}

interface WorkPlace extends Base {
  field: "workplaceType"
  value: "SCHOOL" | "DISTRICT_NETWORK" | "OTHER" | null
}

interface Role extends Base {
  field: "role"
  value:
    | "DISTRICT_CEO"
    | "DISTRICT_CAO"
    | "DISTRICT_DIRECTOR_OF_INSTRUCTION"
    | "DISTRICT_DIRECTOR_IT"
    | "DISTRICT_DIRECTOR_OTHER"
    | "DISTRICT_OTHER"
    | "SCHOOL_PRINCIPAL"
    | "SCHOOL_AP"
    | "TEACHER_GEN_ED"
    | "TEACHER_SPED_INCLUSION"
    | "TEACHER_INSTRUCTIONAL_SUPPORT"
    | "TEACHER_ESOL_ELL"
    | "TEACHER_SPED_SELF_CONTAINED"
    | "TEACHER_INTERVENTION"
    | "TEACHER_RESOURCE"
    | "OTHER_COUNSELOR"
    | "OTHER_PARAPROFESSIONAL"
    | "OTHER_OFFICE_STAFF"
    | "OTHER_TECH_COORDINATOR"
    | "OTHER"
    | null
}

type OnboardingEntries = Base &
  (
    | {
        field: "lastOnboardingStep"
        value: number
      }
    | {
        field: "onboardingInProgress"
        value: boolean
      }
  )

export type Payload = StringEntries | Salutation | WorkPlace | Role | OnboardingEntries

export default function userUpdateAccount(payload: Payload): PreparedAction {
  return {
    name: "USER_UPDATE_ACCOUNT",
    payload: payload,
    patches: patches(payload),
    undoPatches: null,
    narrative: null,
  }
}

const patches = function (payload: Payload): Array<PatchModel> {
  let patch = Patch.create("user", payload.userId).set(
    `attributes.${payload.field}`,
    payload.value
  ).patch
  return [patch]
}
